module.exports = __webpack_public_path__ + "static/media/backup_06.ccba8c3f.svg";